import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  to?: string;
  label: string;
  onClick?: (e: React.MouseEvent) => void;
}

const Tag: React.FC<Props> = ({ to, label, onClick }) => {
  if (!to) {
    return (
      <span
        className='block rounded-full border border-solid border-gray-200 bg-gray-50 px-3 py-1 text-xs'
        data-testid='tag-link'
      >
        {label}
      </span>
    );
  }

  return (
    <Link
      to={to ?? ''}
      className='block cursor-pointer rounded-full border border-solid border-gray-200 bg-gray-50 px-3 py-1 text-xs transition-opacity hover:opacity-80'
      onClick={onClick}
      data-testid='tag-link'
    >
      {label}
    </Link>
  );
};

export default Tag;
